// extracted by mini-css-extract-plugin
export default {"tooltipIcon":"wrWQw7p7BbYkePKM9POe","labelWrapper":"bKFlGF_k1ykzcYrM3J39","tooltip":"lACzO88Mt2A1D0zryHbP"};